import React, { Fragment, useState, useEffect, useContext } from "react";
import { Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, Image } from "../../../AbstractElements";
import {
  EmailAddress,
  ForgotPassword,
  LoginWithJWT,
  Password,
  RememberPassword,
} from "../../../Constant";
import { Link, useNavigate } from "react-router-dom";
import man from "../../../assets/images/dashboard-2/1.png";
import { signinUser } from "../../../Services/Auth.service";
import { megaLogo } from "../../../api";
import { useForm } from "react-hook-form";
import {
  HomePageMapping,
  Admin,
  Dispatch,
  Capture,
  Accountant,
  ShiftInCharge,
  AirportAgent,
  OnboardingAgent,
  VendorAgent,
} from "../../../Data/SideMenu/RouteMapping";

const LoginTab = () => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();
  //   {
  //   defaultValues: {
  //     email: "testcapture@gmail.com",
  //     password: "unknown@mega",
  //   },
  // }
  const [loading, setLoading] = useState(false);
  const [togglePassword, setTogglePassword] = useState(false);
  const [loginUserRes, setLoginUserRes] = useState(() => {
    return {
      message: null,
      color: null,
    };
  });
  const history = useNavigate();

  useEffect(() => {
    const jwt_token = localStorage.getItem("token");
    if (jwt_token) {
      history(`${process.env.PUBLIC_URL}/${localStorage.getItem("homePage")}`);
    }
  }, []);

  const loginWithJwt = (formValues) => {
    // if (!email || !password) return;
    const { email, password } = formValues;
    setLoading(true);
    const body = { email, password };
    signinUser(body)
      .then((result) => {
        const token = result.data.accessToken;
        const userRole = result.data?.userRole ? result.data?.userRole.map(element => {
          return element.authority
        }) : [];
        localStorage.setItem('email', email);
        localStorage.setItem("userDetails", JSON.stringify(result.data));
        localStorage.setItem("profileURL", man);
        localStorage.setItem("Name", result.data?.userName.trim());
        localStorage.setItem("aggregatorId", result.data?.aggregatorId);
        localStorage.setItem("token", token);
        localStorage.setItem("role", JSON.stringify(userRole || []));

        const dispatchUser = userRole.some((element) => element == Dispatch);
        const captureUser = userRole.some((element) => element == Capture);

        const adminUser = userRole.some((element) => element == Admin);
        const accountantUser = userRole.some((element) => element == Accountant);
        const shiftInChargeUser = userRole.some((element) => element == ShiftInCharge);
        const airportAgentUser = userRole.some((element) => element == AirportAgent);
        const onBoardingAgentUser = userRole.some((element) => element == OnboardingAgent);
        const vendorAgentUser = userRole.some(
          (element) => element == VendorAgent
        );

        if (adminUser) {
          localStorage.setItem("homePage", HomePageMapping[Admin]);
        } else if (dispatchUser) {
          localStorage.setItem("homePage", HomePageMapping[Dispatch]);
        } else if (captureUser) {
          localStorage.setItem("homePage", HomePageMapping[Capture]);
        }else if (accountantUser) {
          localStorage.setItem("homePage", HomePageMapping[Accountant]);
        }else if (shiftInChargeUser) {
          localStorage.setItem("homePage", HomePageMapping[ShiftInCharge]);
        }else if (airportAgentUser) {
          localStorage.setItem("homePage", HomePageMapping[AirportAgent]);
        }else if (onBoardingAgentUser) {
          localStorage.setItem("homePage", HomePageMapping[OnboardingAgent]);
        } else if (vendorAgentUser) {
          localStorage.setItem("homePage", result.data?.userName.trim());
        }

        // if (email.toLocaleLowerCase() == "ysquareadmin@gmail.com") {
        //   localStorage.setItem("homePage", "dashboard/capture-dashboard");
        //   localStorage.setItem("role", "Admin");
        // } else if (email.toLowerCase() == "testcapture@gmail.com") {
        //   localStorage.setItem("homePage", "dashboard/capture-dashboard");
        //   localStorage.setItem("role", "Capture");
        // } else {
        //   localStorage.setItem("homePage", "dashboard/dispatch-dashboard");
        //   localStorage.setItem("role", "Dispatch");
        // }
        setLoading(false);
        let homePage = localStorage.getItem("homePage")
        if (homePage) {
          window.location.href = `${process.env.PUBLIC_URL
            }/${homePage}`;
        } else {
          setLoginUserRes({
            message: "User does not have required access to be logged in.",
            color: "red",
          });
          setLoading(false);
        }
      })
      .catch((error) => {
        const errorRes = error.response;
        console.log(errorRes.status, "erroris");
        if (errorRes.status == 401) {
          setLoginUserRes({
            message: "Invalid Email ID or password",
            color: "red",
          });
          setLoading(false);
        } else {
          setLoginUserRes({
            message: errorRes?.data?.message ? errorRes.data.message : "Something went wrong",
            color: "red",
          });
          setLoading(false);
        }
      });

    // return fetch('/users/authenticate', requestOptions)
    //   .then(handleResponse)
    //   .then((user) => {
    //     // store user details and jwt token in local storage to keep user logged in between page refreshes

    //     return user;
    //   });
  };

  return (
    <Fragment>
      <Form className="theme-form" onSubmit={handleSubmit(loginWithJwt)}>
        <Row className="customer-logo">
          <Image
            attrImage={{
              className: "img-fluid d-inline",
              src: megaLogo,
              alt: "",
            }}
          />
        </Row>
        <FormGroup>
          <Label className="col-form-label">{EmailAddress}</Label>
          <input
            className="form-control"
            type="text"
            placeholder="Enter Email ID"
            {...register("email", {
              required: {
                value: true,
                message: "Email is required",
              },
              onChange: (e)=>{
                setLoginUserRes({
                  message: null,
                  color: null,
                });
              }
            })}
          />
        </FormGroup>
        <span style={{ color: "red" }}>{errors?.email?.message}</span>
        <FormGroup className="position-relative">
          <Label className="col-form-label">{Password}</Label>
          <input
            className="form-control"
            placeholder="Enter Password"
            type={togglePassword ? "text" : "password"}
            {...register("password", {
              required: {
                value: true,
                message: "Password is required",
              },
              onChange: (e)=>{
                setLoginUserRes({
                  message: null,
                  color: null,
                });
              }
            })}
          />
          <div
            className="show-hide"
            onClick={() => setTogglePassword(!togglePassword)}
          >
            <span className={togglePassword ? "" : "show"}></span>
          </div>
        </FormGroup>
        <span style={{ color: "red" }}>{errors?.password?.message}</span>
        <div className="position-relative form-group mb-0">
          {/* <div className="checkbox">
            <Input id="checkbox1" type="checkbox" />
            <Label className="text-muted" for="checkbox1">
              {RememberPassword}
            </Label>
          </div> */}
          <Link to={`${process.env.PUBLIC_URL}/forgot-pwd`}>
            {ForgotPassword}
          </Link>
          <div className="mt-2">
            {loginUserRes.message ? (
              <span style={{ color: loginUserRes.color }}>
                {loginUserRes.message}
              </span>
            ) : (
              ""
            )}
          </div>

          <Btn
            attrBtn={{
              color: "primary",
              className: "d-block w-100 mt-2",
              disabled: loading ? loading : loading,
              type: "submit",
            }}
          >
            {loading ? "LOADING..." : LoginWithJWT}
          </Btn>
        </div>
        {/* <SocialAuth /> */}
      </Form>
    </Fragment>
  );
};

export default LoginTab;
